/*
 * @Author: Dom
 * @Date: 2022-05-13 09:27:30
 * @LastEditTime: 2022-06-20 10:31:31
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\services\user.ts
 */
import request from '@/utils/request';
import {UserInfoParams} from './data.d'

export async function queryCurrent(params:UserInfoParams): Promise<any> {
    return request({
        url: '/seller/v1/user/getAuthenticationInfo',
        method: 'get',
        params
    });
}

export async function queryMessage(): Promise<any> {
    return request({
        url: '/user/message'
    });
}
